var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbitGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 171,
    viewBox: "0 0 168 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_4504_359277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.823,
    cy: 49.9114,
    r: 29.9114,
    fill: "#4E17F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_4504_359277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.2154,
    cy: 102.697,
    r: 52.7848,
    fill: "#4E17F1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_4504_359277)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.9114,
    cy: 95.6575,
    r: 29.9114,
    fill: "#4E17F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4504_359277",
    x: 19.9116,
    y: 0,
    width: 99.8228,
    height: 99.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4504_359277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4504_359277",
    x: 23.4307,
    y: 29.9121,
    width: 145.57,
    height: 145.569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4504_359277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4504_359277",
    x: -10,
    y: 45.7461,
    width: 99.8228,
    height: 99.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4504_359277"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitGlow);
export default __webpack_public_path__ + "static/media/orbit-glow.e1f0bf91fe6c8afcfcfb054d2e9b29c1.svg";
export { ForwardRef as ReactComponent };